import { CommonModule } from '@angular/common';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { LoaderService } from '../../../base-classes/loader-service';

@Component({
    selector: 'app-base-loader',
    imports: [CommonModule],
    templateUrl: './base-loader.component.html',
    styleUrl: './base-loader.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class BaseLoaderComponent {
  loaderService = inject(LoaderService);
}
